import ErrorBoundary from '../components/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const withErrorBoundary = WrappedComponent => {
  function WithErrorBoundary(props) {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      fallbackContent: props.children,
      children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
    });
  }
  return WithErrorBoundary;
};
export default withErrorBoundary;